module.exports = __webpack_public_path__ + "img/gold20.7f6dba01.png";